"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tipTapSchema = exports.tipTapBaseExtensions = exports.tipTapLeanExtensions = void 0;
const core_1 = require("@tiptap/core");
const extension_subscript_1 = require("@tiptap/extension-subscript");
const extension_superscript_1 = require("@tiptap/extension-superscript");
const extension_color_1 = require("@tiptap/extension-color");
const link_1 = require("./extensions/link");
const custom_list_item_1 = require("./extensions/custom-list-item");
const custom_bullet_list_1 = require("./extensions/custom-bullet-list");
const custom_ordered_list_1 = require("./extensions/custom-ordered-list");
const list_key_item_1 = require("./extensions/list-key-item");
const starter_kit_1 = require("@tiptap/starter-kit");
const decorateSelection_1 = require("./extensions/decorateSelection");
const font_family_1 = require("./extensions/font-family");
const font_size_1 = require("./extensions/font-size");
const shadow_1 = require("./extensions/shadow");
const strike_1 = require("./extensions/strike");
const text_style_1 = require("./extensions/text-style");
const underline_1 = require("./extensions/underline");
exports.tipTapLeanExtensions = [
    starter_kit_1.StarterKit.configure({
        history: false,
        bulletList: false,
        orderedList: false,
        listItem: false,
        strike: false,
        bold: false,
        blockquote: false,
        heading: false,
        horizontalRule: false,
        code: false,
        codeBlock: false,
        italic: false,
    }),
];
exports.tipTapBaseExtensions = [
    starter_kit_1.StarterKit.configure({
        history: false,
        bulletList: false,
        orderedList: false,
        listItem: false,
        strike: false,
    }),
    text_style_1.TextStyle,
    underline_1.Underline,
    custom_list_item_1.CustomListItem,
    custom_ordered_list_1.CustomOrderedList,
    custom_bullet_list_1.CustomBulletList,
    list_key_item_1.ListKeymap,
    font_size_1.FontSizeExtension,
    font_family_1.FontFamily.configure({
        types: ['textStyle'],
    }),
    strike_1.Strike,
    extension_color_1.Color,
    shadow_1.Shadow,
    decorateSelection_1.decorateSelection,
    extension_subscript_1.Subscript,
    extension_superscript_1.Superscript,
    link_1.Link.configure({
        defaultProtocol: 'https',
        autolink: false,
    }),
];
exports.tipTapSchema = (0, core_1.getSchema)(exports.tipTapBaseExtensions);
//# sourceMappingURL=tip-tap-schema.js.map